export default "__VITE_ASSET__f79ef014__"